import { ethers, toBeHex } from "ethers";
import { RPC } from '@/common/config'
import { getSignData } from '@/common/contractJs/mint'
import axios from 'axios'
import store from "@/store";
import { Notification } from 'element-ui'
import wallet from "./wallet"
const BSC_CONFIG = wallet.BSC_CONFIG
const CURRENT_NETWORK = wallet.CURRENT_NETWORK
const apiUrl = BSC_CONFIG[CURRENT_NETWORK].apiUrl

export function detectDevice() {
	const ua = navigator.userAgent;
	const isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(ua);
	return isMobile ? 'H5' : 'PC';
}

export function getResult(hash) {
	//console.log('hash===>',hash)
	const provider = new ethers.JsonRpcProvider(RPC)
	return new Promise((resolved, rejected) => {
		let sum = 0
		let inter = setInterval(async () => {
			let res = await provider.getTransactionReceipt(hash)
			console.log('res====>', res)
			if (res.result && res.result.status === '0x1') {
				clearInterval(inter)
				resolved('success')
			} else {
				sum++
			}
			if (sum === 10) {
				clearInterval(inter)
				rejected('error')
			}
		}, 2000)
	})
}

export function formateDecimalNumber(number) {
	//最多保留6位小数 向下去整
	//少于2位小数时，自动补0
	if (isNaN(number)) {
		return false
	}
	let numberString = number.toString()
	let pointIndex = numberString.indexOf('.')
	let resNumber = 0
	if (pointIndex > -1) {
		let num = numberString.split('.')[1]
		if (num.length > 6) {
			resNumber = numberString.split('.')[0] + '.' + num.substr(0, 6)
		} else if (num.length < 2) {
			resNumber = numberString + '0'
		} else {
			resNumber = numberString
		}
	} else (
		resNumber = Number(number).toFixed(2)
	)
	return Number(resNumber)
}

export function debounce(fn, delay) {
	let timer = null;
	return function (...args) {
		if (timer) clearTimeout(timer);
		timer = setTimeout(() => {
			fn.apply(this, args);
		}, delay);
	};
}

export function sign() {
	let address = store.state.walletAddress
	let url = `${apiUrl}/address/getMessage?address=${address}`
	let timestamp = ''
	axios.get(url).then(res => {
		timestamp = res.data.data.timestamp
		return getSignData(res.data.data.message)
	}).then(res => {
		//console.log('res', res)
		postSignData(res, address, timestamp)
	}).catch(err => {
		if (err.message.indexOf('user rejected action') > -1) return;
		let index = err.message.indexOf('(')
    let msg = err.message.substring(0, index)
		console.log('err', err)
		Notification.error({
			title: '错误',
			message: msg
		});
	})
}

function postSignData(signMsg, address, timestamp) {
	console.log('signMsg', signMsg)
	const { r, s, v } = ethers.utils.splitSignature(signMsg)
	console.log(r, s, v)
	axios.post(
		`${apiUrl}/address/login`,
		{
			address, timestamp, r, s, v: ethers.utils.hexlify(v)
		}
	).then(res => {
		console.log('res', res)
		localStorage.setItem('rwabs_api_token', res.data.data.token)
		store.state.apiToken = res.data.data.token
	})
}

export function formatTimes(timestamp, separator = '-') {
	if (timestamp.toString().length === 10) {
		timestamp *= 1000
	}

	const date = new Date(timestamp)

	// 获取日期组件
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')

	// 获取时间组件
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	const seconds = String(date.getSeconds()).padStart(2, '0')

	// 组装结果
	return `${year}${separator}${month}${separator}${day} ${hours}:${minutes}:${seconds}`
}

export function formatTimes2(timestamp, separator = '-') {
	if (timestamp.toString().length === 10) {
		timestamp *= 1000
	}

	const date = new Date(timestamp)

	// 获取日期组件
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')

	// 获取时间组件
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	const seconds = String(date.getSeconds()).padStart(2, '0')

	// 组装结果
	return `${year}${separator}${month}${separator}${day} ${hours}:${minutes}`
}

export function formatTimes3() {
	const date = new Date()
	// 获取日期组件
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')

	// 获取时间组件
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	const seconds = String(date.getSeconds()).padStart(2, '0')

	// 组装结果
	return `${year}-${month}-${day} `
}